<div class="card-wrapper">
  <ion-card
    [ngClass]="jackpotTrigger?.jackpot_name === 'EuroMillions' ? 'blue-section' : jackpotTrigger?.jackpot_name === 'Lotto' ? 'red-section' : 'brown-section'">
    <ion-card-header class="ion-display-flex flex-column ion-align-items-center ion-justify-content-center">
      <img class="topimg" title="Jackpot Image" src="{{jackpotTrigger?.jackpot_image}}" />
      <h4>{{translatedData?.title}}</h4>
    </ion-card-header>
    <ion-card-content>
      <div>
        <p class="pop-desc">{{translatedData?.description_1}}</p>
        <p>{{translatedData?.description_2}}</p>
      </div>
      <ion-button (click)="deactivateTrigger()" class="turn-off-btn">{{translatedData?.turn_off_button}}</ion-button>
      <p class="sub-link" (click)="closeBox()">{{translatedData?.back_button}}</p>
    </ion-card-content>
  </ion-card>
</div>